import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import * as config from '@/config';

export const getPendingBroadcastMessages = createAsyncThunk(
    'GET_PENDING_BROADCASTS',
    async () => {
        const res = await axios.get(`${config.API_URL}broadcast-messages/pending`);
        return res.data;
    }
);

export const actionBroadcastMessage = createAsyncThunk(
    'ACTION_BROADCAST',
    async ({ id, action }) => {
        const res = await axios.post(`${config.API_URL}broadcast-messages/${id}/action`, { action });
        return { id, action, data: res.data };
    }
);
